import { render, staticRenderFns } from "./groupBuy.vue?vue&type=template&id=c9ba300e&"
import script from "./groupBuy.vue?vue&type=script&lang=ts&"
export * from "./groupBuy.vue?vue&type=script&lang=ts&"
import style0 from "./groupBuy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "groupBuy.vue"
export default component.exports